import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  computed,
  inject,
  onBeforeUnmount,
  onMounted,
  provide,
  ref,
  watch,
} from "vue";
import { Core, EventObject } from "cytoscape";
import { useRoute } from "vue-router";
import { CytoEvent } from "@/types";
import { layoutStore } from "@/hooks";


/**
 * A wrapper for managing a right click context menu on the graph.
 */
const __default__ = {
  name: "CyContextMenu",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentRoute = useRoute();

const cy = inject<Promise<Core>>("cy");

const instance = ref<Core | undefined>(undefined);

const pos = ref<{ x: number; y: number } | undefined>();
const style = ref("");

const display = computed(() => !!pos.value);

/**
 * Closes the context menu.
 */
function handleCloseMenu() {
  if (pos.value) {
    pos.value = undefined;
  }
  if (style.value) {
    style.value = "";
  }
}

/**
 * Sets up all event handlers.
 */
function listenForEmits(): void {
  const handleRightClick = (event: EventObject) => {
    const oldPos = pos.value;
    const newPos = event.renderedPosition;

    if (oldPos?.x !== newPos.x || oldPos?.y !== newPos.y) {
      pos.value = { ...newPos };
      style.value = `
        left: ${newPos.x}px;
        top: ${newPos.y}px;
      `;
    }
  };

  instance.value?.on(CytoEvent.CXT_TAP, handleRightClick);
  instance.value?.on(CytoEvent.CLICK, handleCloseMenu);
  instance.value?.on(CytoEvent.PAN_ZOOM, handleCloseMenu);
}

provide("menu-close", handleCloseMenu);

/**
 * Listen for right click events to create the context menu.
 */
onMounted(() => {
  cy?.then((cy: Core) => {
    instance.value = cy;

    listenForEmits();
  });
});

/**
 * Cleanup event listeners on unmount.
 */
onBeforeUnmount(() => {
  instance.value?.off(CytoEvent.CXT_TAP);
  instance.value?.off(CytoEvent.CLICK);
  instance.value?.off(CytoEvent.PAN_ZOOM);
});

watch(() => layoutStore.mode, handleCloseMenu);
watch(() => currentRoute.path, handleCloseMenu);

return (_ctx: any,_cache: any) => {
  return (display.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(style.value),
        class: "cy-menu-position"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4))
    : _createCommentVNode("", true)
}
}

})